<template>
    <div class="text-center mt-14">
      <v-container>        
        <v-card>
        <v-card-title>Register Device</v-card-title>
        <v-card-subtitle >
            User: {{ userProfile.EMPMST_NAME }}            
        </v-card-subtitle>
        <v-card-text>
            Email: {{ userProfile.EMPMST_EMAIL }}         
        
            <v-form ref="form" v-model="valid">
                <v-otp-input
                length="6"
                type="number"
                ></v-otp-input>             
            </v-form>
        </v-card-text>
        <v-card-actions>            
            <v-btn :disabled="!valid" color="primary" @click="requestOTP">
                Get OTP
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!valid" color="primary" @click="requestOTP">
                Register Device
            </v-btn>
        </v-card-actions>
      </v-card>   

      </v-container>
    </div> 
</template>
<script>
import secure_axios from "../services/secure_axios";
import { v4 as uuidv4 } from 'uuid';
import CryptoJS from 'crypto-js';

export default {
    data() {
        return {
        secretKey : null,
        localTestAPI:null,
        OTP:null,
        };
    },
    computed: {   
        sessionAPI() {
            if (this.localTestAPI){
            return this.localTestAPI;
            }
            else{
            return this.$store.getters.sessionAPI;  
            }
        },
        fbuser(){
            return this.$store.getters.fbuserdata
        },
        user() {     
            return this.$store.getters.factsuser;      
        },
        userProfile(){
            return this.$store.getters.userProfile;
        },
        thisfcmToken(){
            return this.$store.getters.fcmToken;
        }
    },
    methods: {
        setDeviceIdentifer(){       
            const deviceId = uuidv4();
            localStorage.setItem('device_id', deviceId);
        },
        getDeviceIdentifier() {
            let deviceId = localStorage.getItem('device_id');
            if (deviceId) {
            return deviceId;
            }        
        },   
        requestOTP() {
        // Call API to send OTP to user's email
        const email = this.userProfile.email;
        secure_axios.post('/request_otp', { email })
            .then(response => {
                if(response)
                this.$toast.success('OTP sent to email');
            })
            .catch(error => {
            console.error('Error requesting OTP:', error)
            this.$toast.success('Error requesting OTP');
            });
        },    
        verifyOTP() {
            const userId = this.user.USER_LOGINID;
            const otp = this.otpInput; // OTP entered by the user

            secure_axios.post('/verify_otp', { userId, otp })
            .then(response => {
                if (response=="success")
                this.secretKey = otp;
                this.$toast.success('OTP verified successfully!');
            })
            .catch(error => {
                console.error('OTP verification failed:', error);
                this.$toast.error('OTP verification Failed!');
                
            });
        },
        registerDevice() {
            this.verifyOTP().then(() => {
            // Once OTP is verified, proceed with device registration
            const deviceId = this.encryptedDeviceId;
            secure_axios.post('/register_device', { deviceId })
            .then(response => {
                if (response.status==200)
                this.$toast.success('Device registered successfully');
            })
            .catch(error => {
                console.error('Error registering device:', error);
                this.$toast.error('Error registering device');
            });
        });
        },
        encryptData(data) {
            if (!this.secretKey) return '';
            return CryptoJS.AES.encrypt(data, this.secretKey).toString();
        },
        decryptData(encryptedData) {
            if (!this.secretKey) return '';
            const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
            return bytes.toString(CryptoJS.enc.Utf8);
        },
        
    }
};
</script>